
(function () {
  const root = document.documentElement;
  const toggle = document.querySelector('[data-theme-toggle]');
  let theme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

  function applyTheme(nextTheme) {
    theme = nextTheme;
    root.setAttribute('data-theme', theme);
    if (toggle) {
      toggle.textContent = theme === 'dark' ? 'Light' : 'Dark';
      toggle.setAttribute('aria-label', 'Switch to ' + (theme === 'dark' ? 'light' : 'dark') + ' mode');
    }
  }

  applyTheme(theme);

  toggle && toggle.addEventListener('click', function () {
    applyTheme(theme === 'dark' ? 'light' : 'dark');
  });

  document.addEventListener('click', function (event) {
    const menuButton = event.target.closest('[data-menu-toggle]');
    if (menuButton) {
      const links = document.querySelector('[data-nav-links]');
      links && links.classList.toggle('is-open');
    }

    const filterButton = event.target.closest('[data-filter]');
    if (filterButton) {
      const filter = filterButton.getAttribute('data-filter');
      document.querySelectorAll('[data-filter]').forEach(function (button) {
        button.classList.toggle('is-active', button === filterButton);
      });
      document.querySelectorAll('[data-product-card]').forEach(function (card) {
        const tags = card.getAttribute('data-tags') || '';
        card.hidden = filter !== 'All' && !tags.includes(filter);
      });
    }
  });
})();
